import { render, staticRenderFns } from "./agentBoard.vue?vue&type=template&id=571fe3da&scoped=true"
import script from "./agentBoard.vue?vue&type=script&lang=js"
export * from "./agentBoard.vue?vue&type=script&lang=js"
import style0 from "./agentBoard.vue?vue&type=style&index=0&id=571fe3da&prod&lang=scss"
import style1 from "./agentBoard.vue?vue&type=style&index=1&id=571fe3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571fe3da",
  null
  
)

export default component.exports